import React from 'react';
import { Popover as AntPopover, PopoverProps as AntPopoverProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface PopoverProps extends AntPopoverProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  popover: {
    '& .ant-popover-inner': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
      padding: theme.spacing[3],
      borderRadius: theme.radius.sm,
      boxShadow: theme.shadow.md,
    },
    '& .ant-popover-inner-content': {
      color: theme.color.semantic.text.primary,
    },
    '& .ant-popover-title': {
      color: theme.color.semantic.text.primary,
      borderBottomColor: theme.color.semantic.border.subtle,
    },
    '& .ant-popover-arrow-content': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
    },
  },
}));

const Popover: React.FC<PopoverProps> = ({ className = '', overlayClassName = '', ...rest }) => {
  const classes = useStyles();
  return (
    <AntPopover
      {...rest}
      overlayClassName={`${classes.popover} ${overlayClassName}`.trim()}
      className={className}
    />
  );
};

export default Popover;
